import { useLang, tx } from "@/context/LangContext";
import { T } from "@/data/content";

export default function EmptySlot({
    label,
    icon: Icon,
    aspect = "aspect-[4/3]",
    dark = false,
    testid,
    index,
}) {
    const { lang } = useLang();
    return (
        <div
            data-testid={testid}
            className={`relative flex w-full flex-col items-center justify-center gap-3 border border-dashed px-6 text-center md:gap-4 ${dark ? "border-cream/30" : "border-ink/25"} ${aspect}`}
        >
            <span
                className={`absolute left-4 top-4 font-mono text-[9px] tracking-[0.3em] ${dark ? "text-cream/40" : "text-ink/35"}`}
            >
                SLOT {String(index || 1).padStart(2, "0")}
            </span>
            {Icon && (
                <span
                    className={`flex h-14 w-14 items-center justify-center rounded-full border ${dark ? "border-cream/30" : "border-ink/25"}`}
                >
                    <Icon
                        size={18}
                        className={dark ? "text-cream/60" : "text-ink/50"}
                    />
                </span>
            )}
            <p
                className={`font-display text-lg font-bold uppercase leading-tight tracking-tight md:text-2xl ${dark ? "text-cream/80" : "text-ink/70"}`}
            >
                {label}
            </p>
            <p
                className={`font-mono text-[9px] tracking-[0.3em] md:text-[10px] ${dark ? "text-cream/40" : "text-ink/35"}`}
            >
                {tx(lang, T.empty.waiting)}
            </p>
        </div>
    );
}
